import { render, staticRenderFns } from "./URLsInput.vue?vue&type=template&id=052e9962&scoped=true&"
import script from "./URLsInput.vue?vue&type=script&lang=js&"
export * from "./URLsInput.vue?vue&type=script&lang=js&"
import style0 from "./URLsInput.vue?vue&type=style&index=0&id=052e9962&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "052e9962",
  null
  
)

export default component.exports